import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SEOHead from "@/components/SEOHead";
import ScrollToTop from "@/components/ScrollToTop";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import AllInOneSection from "@/components/landing/AllInOneSection";
import AppShowcaseSection from "@/components/landing/AppShowcaseSection";
import PartnersSection from "@/components/landing/PartnersSection";
import WhySection from "@/components/landing/WhySection";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";

const Index = () => {
  return (
    <>
      <SEOHead
        title="MySabbat – Din guide til det perfekte sabbatår"
        description="MySabbat samler job, rejser, højskole og planlægning i én app. Planlæg dit sabbatår med mere retning. Kommer snart til iOS & Android."
        path=""
        keywords={["sabbatår", "sabbatår app", "sabbatår guide", "gap year", "højskole", "working holiday", "backpacking"]}
      />
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <ScrollToTop />
        <main>
          <HeroSection />
          <FeaturesSection />
          <AllInOneSection />
          <AppShowcaseSection />
          <PartnersSection />
          <WhySection />
          <PricingSection />
          <FAQSection />
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </>
  );
};

export default Index;
